module.exports = __webpack_public_path__ + "img/logo.a7cf0dc1.png";